// src/modules/app-views/dataSearch/pages/Search/components/EmptyState.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, Card } from 'antd';
import translateX from 'utils/translateX';
import SearchHeader from './SearchHeader';
import InputForm from './InputForm';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
/**
 * EmptyState - Initial prompt screen with form for data search
 */
const EmptyState = ({
  formRef,
  isProcessing,
  lastFormValues,
  selectedEngine,
  selectedSearchType,
  searchEngines,
  searchTypeOptions,
  creditsInfo,
  isMobile,
  onEngineChange,
  onSearchTypeChange,
  onFinish,
  onBackToWelcome,
  onOpenCreditsDrawer,
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <SearchHeader isMobile={isMobile} showLearnMore>
      <Card style={{ width: '100%', maxWidth: 580 }}>
        <InputForm
          formRef={formRef}
          isProcessing={isProcessing}
          lastFormValues={lastFormValues}
          selectedEngine={selectedEngine}
          selectedSearchType={selectedSearchType}
          searchEngines={searchEngines}
          searchTypeOptions={searchTypeOptions}
          creditsInfo={creditsInfo}
          onEngineChange={onEngineChange}
          onSearchTypeChange={onSearchTypeChange}
          onFinish={onFinish}
          onBackToWelcome={onBackToWelcome}
          onOpenCreditsDrawer={onOpenCreditsDrawer}
        />
      </Card>
      {/* Links below the card */}
      <Flex gap={24} style={{ marginTop: 16 }}>
        <a onClick={onBackToWelcome} style={{ fontSize: 14, cursor: 'pointer' }}>
          {translateX('go_back')}
        </a>
      </Flex>
    </SearchHeader>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default EmptyState;
